export const filterNotificationsData = [
  {
    id: 1,
    nome: "Progetto",
  },
];
